<template>
  <div class="w-full" :class="{'o-hidden':o_hidden}">
    <div :radio="RadioValue" class="relative top-0 " :class="{'o-hidden':o_hidden}">
      <slot></slot>
      <div :style="{paddingTop:RadioValue + '%'}" class="radioclass"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RatioDiv',
  props: {
    RadioValue: {
      type: Number,
      default: 100
    },
    o_hidden: {
      type: Boolean,
      default: true,
    }
  },
  computed: {},
  data () {
    return {}
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    }
  }
}
</script>

<style lang="scss" scoped>
.radioclass {
  display: block;
  width: 100%;
  content: '';
}

</style>



// WEBPACK FOOTER //
// src/components/common/RatioDiv.vue